function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M1.954 2.719L.838 1.602l.587-.592 7.388 7.392-.588.588L6.8 7.565c-.558.22-1.167.341-1.8.341-2.083 0-3.862-1.295-4.583-3.125.32-.82.858-1.529 1.537-2.062zM5 2.489c1.58 0 2.988.888 3.675 2.292-.246.509-.592.946-1.004 1.3l.587.588c.58-.513 1.038-1.154 1.325-1.888-.72-1.829-2.5-3.125-4.583-3.125-.53 0-1.037.084-1.517.238l.688.687c.27-.054.546-.091.829-.091zm-.446.476l.863.862c.237.104.429.296.533.534l.863.862c.033-.142.058-.292.058-.446.004-1.033-.838-1.87-1.871-1.87-.154 0-.3.02-.446.058zm-.591 1.762L5.05 5.815c-.017.004-.033.008-.05.008-.575 0-1.042-.467-1.042-1.042l.002-.027c.001-.008.003-.016.003-.027zm-.688-.687l-.73-.73c-.503.384-.928.875-1.22 1.471C2.013 6.185 3.421 7.073 5 7.073c.396 0 .78-.058 1.146-.158l-.408-.409c-.225.096-.475.15-.738.15-1.033 0-1.875-.841-1.875-1.875 0-.262.054-.512.15-.741z",
  clipRule: "evenodd"
});

var SvgIcUnvisibility = function SvgIcUnvisibility(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcUnvisibility, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_unvisibility.ab5f8b9e.svg";
export { ForwardRef as ReactComponent };